export default __webpack_public_path__ + "static/media/imperial_palace.a47241ef.jpeg";